import { UntypedFormControl, UntypedFormGroup } from "@angular/forms";

export interface MultiSessionLimitTemplate {
	activeFrom: string;
	limitValue: number;
	limitPeriod: string;
}

export enum MultiSessionLimitPeriod {
	Daily = 1,
	Weekly = 7,
	Monthly = 30,
}

export enum MultiSessionLimitSuggestionAmounts {
	Daily = 24,
	Weekly = 168,
	Monthly = 720,
}

export enum MultiSessionLimitPeriodTranslationsEnum {
	Daily = "dailySessionLimit",
	Weekly = "weeklySessionLimit",
	Monthly = "monthlySessionLimit",
}

export const multiSessionLimitPeriodToSuggestionAmount: Record<
	MultiSessionLimitPeriod,
	MultiSessionLimitSuggestionAmounts
> = {
	[MultiSessionLimitPeriod.Daily]: MultiSessionLimitSuggestionAmounts.Daily,
	[MultiSessionLimitPeriod.Weekly]: MultiSessionLimitSuggestionAmounts.Weekly,
	[MultiSessionLimitPeriod.Monthly]: MultiSessionLimitSuggestionAmounts.Monthly,
};

export const multiSessionLimitPeriodToPeriodTranslation: Record<
	MultiSessionLimitPeriod,
	MultiSessionLimitPeriodTranslationsEnum
> = {
	[MultiSessionLimitPeriod.Daily]: MultiSessionLimitPeriodTranslationsEnum.Daily,
	[MultiSessionLimitPeriod.Weekly]: MultiSessionLimitPeriodTranslationsEnum.Weekly,
	[MultiSessionLimitPeriod.Monthly]: MultiSessionLimitPeriodTranslationsEnum.Monthly,
};

export interface MultiSessionLimitFormGroup extends UntypedFormGroup {
	controls: {
		sessionLimitAmount: UntypedFormControl;
		sessionLimitPeriod: UntypedFormControl;
	};
}
